import { MobileSignInSession, MobileSignInSessionType } from '../../domain/mobile-sign-in';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'ppl-mobile-sign-in-session-item',
  templateUrl: './mobile-sign-in-session-item.component.html',
  styleUrl: './mobile-sign-in-session-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MobileSignInSessionItemComponent {

  @Input() session: MobileSignInSession;

  @Output() signOutClick = new EventEmitter();

  get icon() {
    switch (this.session.app_type) {
      case MobileSignInSessionType.Android:
        return 'android-logo-light-gray';
      case MobileSignInSessionType.iOS:
        return 'apple-logo-light-gray';
    }
  }

}
